<template>
  <div>
    <div v-if="loadingOverlay === true">
      <div>Loading Page...</div>
    </div>
    <div>
      <div style="margin:15px;">
        <a href="/influencer-campaign/create">+ Create New Campaign</a>
      </div>
    </div>
    <div v-if="campaigns !== null">
      <div class="alert alert-dismissible fade show" :class="alertType" v-if="showAlert==true">
        <button
          type="button"
          aria-hidden="true"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <i class="nc-icon nc-simple-remove"></i>
        </button>

        <span>{{alertMsg}}</span>
      </div>
      <div class="card" style="padding-left:10px;">
        <div class="card-header">
          <h5 class="title">Influencer Campaigns</h5>
        </div>
        <div class="card-body table-responsive table-full-width">
          <el-table :data="campaigns">
            <el-table-column label="Brand" property="business.businessName" width="150px"></el-table-column>
            <el-table-column label="Name" property="name"></el-table-column>
            <el-table-column label="Description" property="campaignDescription"></el-table-column>
            <el-table-column label="Start Date" property="startDate"></el-table-column>
            <el-table-column label="Actions" class-name="action-buttons td-actions">
              <template slot-scope="props">
                <el-tooltip content="View Details" :open-delay="300" placement="bottom">
                  <p-button
                    link
                    type="success"
                    size="sm"
                    @click="$router.push('/influencer-campaign/details/'+props.row._id)"
                  >
                    <i class="fa fa-clipboard-list"></i>
                  </p-button>
                </el-tooltip>
                <el-tooltip content="Manage Influencers" :open-delay="300" placement="bottom">
                  <p-button
                    link
                    type="success"
                    size="sm"
                    @click="$router.push('/influencer-campaign/list/'+props.row._id)"
                  >
                    <i class="fa fa-list-ul"></i>
                  </p-button>
                </el-tooltip>
                <el-tooltip content="Edit Campaign" :open-delay="300" placement="bottom">
                  <p-button
                    link
                    type="success"
                    size="sm"
                    @click="$router.push('/influencer-campaign/edit/'+props.row._id)"
                  >
                    <i class="fa fa-edit"></i>
                  </p-button>
                </el-tooltip>
                <el-tooltip content="Analytics" :open-delay="300" placement="bottom">
                  <p-button
                    link
                    type="success"
                    size="sm"
                    @click="$router.push('/influencer-campaign/analytics/'+props.row._id)"
                  >
                    <i class="fa fa-chart-bar"></i>
                  </p-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import { influencerCampaignSearchApi } from "@/config/appSettings";
import { Table, TableColumn, Card, Tooltip, Button, Modal } from "element-ui";
import NotificationTemplate from "@/components/Dashboard/Views/Components/NotificationTemplate";

export default {
  data: () => ({
    loadingOverlay: false,
    campaigns: null,
    type: ["", "info", "success", "warning", "danger"],
    notifications: {
      topCenter: false
    },
    modals: {
      classic: false,
      notice: false,
      mini: false
    },
    alertType: null,
    showAlert: false,
    alertMsg: null
  }),
  name: "InfluencerCampaignList",
  components: {
    Card,
    Modal,
    [Button.name]: Button,
    NotificationTemplate,
    [Tooltip.name]: Tooltip
  },
  methods: {
    async loadCampaignList() {
      try {
        this.loadingOverlay = true;

        let influencerCampaignSearchUrl = `${influencerCampaignSearchApi}/?usertoken=${this.auth}`;
        let influencerCampaignList = await axios.get(
          influencerCampaignSearchUrl
        );
        //console.log("CAMPAIGN DATA: ", influencerCampaignList.data);
        if (influencerCampaignList.data.success === true) {
          this.campaigns = influencerCampaignList.data.result;
          this.loadingOverlay = false;
        }
      } catch (err) {
        console.log(err);
      }
    }
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadCampaignList();
    if (this.$route.query.new == "true") {
      this.showAlert = true;
      this.alertType = "alert-success";
      this.alertMsg = "Campaign created successfully.";
    }
  }
};
</script>

<style scoped>
</style>